import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_materials_textarea",
  "use": "lc_materials_textarea-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_materials_textarea\"><path d=\"M118.784 778.24h778.24V245.76h-778.24v532.48zM77.824 204.8h860.16v614.4H77.824V204.8z m778.24 409.6l-122.88 122.88h122.88V614.4z m-661.504-256v204.8c0 12.288 8.192 20.48 20.48 20.48s20.48-8.192 20.48-20.48V358.4c0-12.288-8.192-20.48-20.48-20.48s-20.48 8.192-20.48 20.48z\" p-id=\"3253\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol